import Input from "components/common/Input";
import SearchIcon from "components/icons/SearchIcon";
import Button from "components/common/Button";
import Colors from "assets/Colors";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import SelectProfileCustomer from "./SelectProfileCustomer";
import s from "../../../styles/TopMenu.styles";

function TopMenu({ changeSearchValue, addWorker, setrolViewList, loading }) {
  const { t } = useTranslation();
  return (
    <s.Container>
      <s.LeftContainer style={{ marginRight: "14px" }}>
        <Row>
          <Col flex={2} style={{ marginRight: "14px" }}>
            <s.Title>
              {t("components.CustomerList.TopMenu.searchItems")}
            </s.Title>
            <Input
              disabled={loading}
              placeholder={t("components.CustomerList.TopMenu.search")}
              style={{
                marginBottom: "14px",
                maxWidth: "340px",
                minWidth: "200px",
              }}
              prefix={<SearchIcon />}
              onChange={(e) => changeSearchValue(e.target.value)}
            />
          </Col>
          <Col flex={3} style={{}}>
            <Row>
              <Col>
                <s.Title>
                  {t("components.CustomerList.TopMenu.selectProfile")}
                </s.Title>
                <SelectProfileCustomer
                  loading={loading}
                  setrolViewList={setrolViewList}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </s.LeftContainer>

      <s.RightContainer>
        <Button
          disabled={loading}
          type="primary"
          style={{
            background: Colors.primary,
            color: Colors.text_on_secondary,
            width: "none",
            fontWeight: "500",
            border: "none",
            height: "40px",
            marginTop: "12px",
          }}
          onClick={addWorker}
        >
          {t("components.CustomerList.TopMenu.addCustomer")}
        </Button>
      </s.RightContainer>
    </s.Container>
  );
}

export default TopMenu;
